import React from "react";
import {
  Checkbox as MUICheckbox,
  FormControlLabel as MUIFormControlLabel,
} from "@mui/material";
import styled from "styled-components";

const StyledMUIFormControlLabel = styled(MUIFormControlLabel)`
  margin-right: 0 !important;

  .MuiCheckbox-root {
    color: var(--colorBorder);
  }

  .MuiCheckbox-colorPrimary.Mui-checked {
    color: var(--primaryColor) !important;
  }

  .MuiIconButton-colorPrimary:hover {
    background-color: #e0e0e0 !important;
  }

  input {
    position: absolute;
    :disabled {
      opacity: 0;
    }
  }
`;

export const Checkbox = ({
  label = null,
  checked,
  onChange,
  color = "primary",
  style,
  size = "large",
  ariaLabel,
  id,
}) => {
  return (
    <StyledMUIFormControlLabel
      control={
        <MUICheckbox
          id={id}
          checked={checked}
          onChange={onChange}
          color={color}
          style={style}
          aria-label={ariaLabel || `${id} checkbox`}
        />
      }
      label={label}
      size={size}
    />
  );
};
